/* eslint-disable prefer-template */
/* eslint-disable react/no-danger */
/* eslint-disable no-constant-condition */
/* eslint-disable no-unused-vars */
/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */


import React, { useState, useEffect,useRef , useLayoutEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import {
  Box, Typography, Button, IconButton, Table, TableHead, TableBody, TableRow, TableCell, Tabs,
  Tab, Grid, Paper, Card, Accordion, AccordionSummary, AccordionDetails, Divider, useTheme, LinearProgress,
  ButtonGroup, Backdrop, CircularProgress,
} from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import adminServices from '../../../services/adminServices';

// import './style.css'


const SATReportReplica = () => {
  const location = useLocation();  
  const [activeTab, setActiveTab] = useState('report');
  const [activeTabs, setActiveTabs] = useState(location.state?.data?.assessment_type === 'Maths Subject Test' ? "m1" : "rw1");
  const [allQuestions, setAllQuestions] = useState([]);
  const [analysis, setAnalysis] = useState([]);
  const [analysisTestScore, setAnalysisTestScore] = useState([]);
  const navigate = useNavigate();
  const section1Ref = useRef(null);
  const section2Ref = useRef(null);

  const userid = useSelector((state) => state?.userInfo && state?.userInfo?.id);
  const [name, setName] = useState(0);
  const [module, setModule] = useState(location.state?.data?.assessment_type === 'Maths Subject Test' ? "Maths" : "English");
  const { userInfo } = useSelector((state) => state);
  const [isLoading , setIsLoading] = useState(null);
  const questionAnalysisRef = useRef(null);


  useEffect(() => {
    if (module && location.state?.comingFrom !== 'ComingfromChapterAnalysis') {
      getAnalysis();
    }
  }, [location.state?.id, module, name])

  useEffect(() => {
    if (location.state?.data?.assessment_type === 'Full Test' && location.state?.data?.assessment_type === 'English Subject Test') {
      setModule('English')
    } else if (location.state?.data?.assessment_type === 'Maths Subject Test') {
      setModule('Maths')
    }
  }, [])

 const handleViewSolutions = (tabId) => {
  setActiveTabs(tabId);
  setTimeout(() => {
    if (questionAnalysisRef.current) {
      const yOffset = -90;
      const y =
        questionAnalysisRef.current.getBoundingClientRect().top +
        window.pageYOffset +
        yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  }, 300);
};

  const useMobileLandscape = () => {
    const [isMobileLandscape, setIsMobileLandscape] = useState(
      window.innerWidth > 600 && window.innerHeight <= 455
    );
    
    useEffect(() => {
      const handleResize = () => {
        setIsMobileLandscape(
          window.innerWidth > 600 && window.innerHeight <= 455
        );
      };
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
    return isMobileLandscape;
  }

  const mobileLandscape = useMobileLandscape();



  const getAnalysis = async () => {
    setIsLoading(true)
    const result = await adminServices.getAdaptiveAssessmentAnalysis(location.state?.id, userid, location?.state.fromindex, module, name)
    if (result.ok) {
      // const allQuestions = result.data?.assessment_modules.flatMap(module => module.matchingQuestions);      



      setAllQuestions(result.data?.questions)
      setAnalysis(result.data)
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getAnalysisTestScore()
  }, [])


  const getAnalysisTestScore = async () => {
     setIsLoading(true)

    const result = await adminServices.getAnalysisTestScoreResult(location.state?.data?.id, userid, location?.state.fromindex, location.state?.data?.assessment_type === 'Maths Subject Test' ?"Maths":"English")
    if (result.ok) {
      setAnalysisTestScore(result.data)
      setIsLoading(false)
    }
  }



  const Header = () => {
    const theme = useTheme();
    return (
      <Box
        sx={{
          width: '100%',
          color: '#fff',
          py: { xs: 4, md: 6 },
          px: { xs: 2, md: 6 },
          borderRadius: 2,
          mt: '100px',
          mb: { xs: 3, md: 5 },
          position: 'relative',
          overflow: 'hidden',
          backgroundColor: `linear-gradient(rgba(31, 78, 216, 0.85), rgba(59, 130, 246, 0.85)) `,
          backgroundSize: 'cover',
          backgroundPosition: 'center 74%',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <Box sx={{}}>
          <Box sx={{ backdropFilter: 'brightness(0.6)', backgroundColor: `linear-gradient(rgba(31, 78, 216, 0.85), rgba(59, 130, 246, 0.85)) ` }}>
            <Grid container alignItems="center" sx={{
              minHeight: '250px',
              backgroundImage: `linear-gradient(rgba(31, 78, 216, 0.60), rgba(59, 130, 246, 0.60)),
  url(https://plus.unsplash.com/premium_photo-1742859699527-2dbda42bfde2?q=80&w=2011&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D)`,
              backgroundSize: 'cover',
              backgroundPosition: 'center 74%',
            }} spacing={2}>
              <Grid item xs={12} md={12} sx={{ padding: '20px' }}>
                <Typography textAlign={'center'} variant="h4" sx={{ fontWeight: 700 }}>
                  Upgrade and experience the most realistic SAT prep Platform
                </Typography>
                <Typography textAlign={'center'} variant="body2" sx={{ mt: 1, opacity: 0.95 }}>
                  Unlock Your Full SAT Potential. Upgrade now to access our complete SAT prep program,
                  featuring adaptive tests, expert-developed materials, and personalized insights.
                </Typography>
                <Box justifyContent={'center'} sx={{ mt: 2, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                  <Button variant="outlined" sx={{
                    borderColor: 'rgba(255,255,255,0.7)', color: '#fff', borderRadius: '4px', width: { sm: 'auto', md: '250px' }, '&:hover': { borderColor: '#0483d2', color: '#fff', backgroundColor: '#0483d2' }
                  }}>Try Free 7 day trial</Button>

                  <Button variant="contained" sx={{ bgcolor: '#fff', color: '#1f4ed8', fontWeight: 700, borderRadius: '4px', width: { sm: 'auto', md: '250px' }, '&:hover': { borderColor: '#0483d2', color: '#fff', backgroundColor: '#0483d2' } }}>Upgrade Now</Button>
                </Box>
              </Grid>

            </Grid>
          </Box>
        </Box>
      </Box>
    );
  };



  const tabData = [
    { id: "rw1", label: "Reading & Writing Module 1" },
    { id: "rw2", label: "Reading & Writing Module 2" },
    { id: "m1", label: `Math Module 1` },
    { id: "m2", label: "Math Module 2" },
    // { id: "chapter", label: "Chapter Test Name"}
  ];

  let visibleTabs = [];
  if (location.state?.data?.assessment_type === 'English Subject Test') {
    visibleTabs = tabData.filter(tab => tab.id === "rw1" || tab.id === "rw2");
  } else if (location.state?.data?.assessment_type === 'Maths Subject Test') {
    visibleTabs = tabData.filter(tab => tab.id === "m1" || tab.id === "m2");
  } else if (location.state?.data?.assessment_type === 'Full Test') {
    visibleTabs = tabData;
  } else if (location.state?.data?.type === "Chapter") {
    visibleTabs = tabData.filter(tab => tab.id === "chapter");
  } else {
    visibleTabs = [];
  }

 
  const handleTabChangeTabs = (event, newValue) => {
    if (location.state?.data?.assessment_type === 'English Subject Test') {
      setName(newValue === "rw1" ? 0 : 1)
    }
    else if (location.state?.data?.assessment_type === 'Maths Subject Test') {
      setName(newValue === "m1" ? 0 : 1)
    }
    else {
      setName(newValue === "rw1" ? 0 : newValue === "rw2" ? 1 : newValue === "m1" ? 2 : 3)

    }
    setModule((newValue === "rw1" || newValue === "rw2") ? "English" : "Maths")
    setActiveTabs(newValue);
  }

  

  const handleNavigation = () => {
    let comingfrom;
    localStorage.setItem('selectedToggle', 'paid');

    if (location.state?.data?.data?.type === "Chapter") {
      comingfrom = "Chapter";
    } else {
      comingfrom = location.state?.data?.assessment_type !== 'Full Test' ? 'Subject' : 'SATsrc';
    }

    const role = userInfo?.role || userid;
    if (role === 'AUTH_USER') {
      navigate('/app/course', { state: comingfrom });
    } else {
      navigate('/auth/subscribe', { state: comingfrom });
    }
  }

const handleNavigateOverview = () => {
  if (userInfo?.role === 'USER_DTC') {
    if (location.state.data.type === "SAT") {
      
      navigate(`/auth/assessment/${encodeURIComponent(location?.state?.data?.title)}/${location?.state?.id}`, {
        state: {
          id: location?.state?.id,
          from: "SAT",
          data: location?.state?.data,
        },
      });
    } else {
      navigate("/auth/ChapterLevelSimulation", {
        state: location.state?.data?.id,
      });
    }
  } else {
    navigate(`/app/assessment/${encodeURIComponent(location?.state?.data?.title)}/${location?.state?.id}`, {
      state: {
        id: location?.state?.id,
        from: "SAT",
        data: location?.state?.data,
      },
    });
  }
};





  const totalScoreFullTest = analysisTestScore?.weightedScores?.englishMidpoint + analysisTestScore?.weightedScores?.mathMidpoint
  const englishTotalScoreFullTest = analysisTestScore?.weightedScores?.englishMidpoint
  const mathsTotalScoreFullTest = analysisTestScore?.weightedScores?.mathMidpoint

  const totalIndividualScore = analysisTestScore?.weightedScores?.midpoint
  const IndividualScoreModule1 = analysisTestScore?.weightedScores?.individualidmidpoint1
  const IndividualScoreModule2 = analysisTestScore?.weightedScores?.individualidmidpoint2

  // eslint-disable-next-line arrow-body-style
  const ScoreCard = () => {
    return (

      <Grid container spacing={2} mt={.5} alignItems="center">

        <Grid item xs={12} md={2.5} sx={{ height: { xs: 'auto', md: '-webkit-fill-available' } }}>
          <Paper sx={{
            ...( mobileLandscape ? { p: 2 ,height: '100%', bgcolor: '#225AD6', borderRadius: 2 } : { 
               p: 2.5, height: '100%', bgcolor: '#225AD6', borderRadius: 2}) }} elevation={0}>
            <Box
              sx={{
                display: 'flex',
                alignItems: { xs: 'center', md: 'flex-start' },
                justifyContent: { xs: 'space-between', md: 'flex-start' },
                gap: { xs: 1.5, md: 0.5 },
                flexDirection: { xs: 'row', md: 'column', lg: 'column' },
              }}
            >
              <Box
                sx={{ 
                  // ...( mobileLandscape ? { 
                //    display: 'flex',
                //   alignItems: 'center',
                //   justifyContent: 'space-between',
                //   flexDirection: 'row',
                // } : {  
                  display: 'flex',
                  alignItems: { xs: 'center', md: 'flex-start' },
                  justifyContent: { xs: 'space-between', md: 'flex-start' },
                  flexDirection: { xs: 'row', md: 'column', lg: 'column' },
                // })
                }}>
                <Typography
                  variant="h6"
                  sx={{ 
                      ...( mobileLandscape ? { fontSize: "12px !important ", color: '#fff' } : {    
                      fontWeight: 700, color: '#fff', pb: { xs: 0, md: 1 }, fontSize:{ xs: '12px', sm:'18px', md: '18px' }  })
                    }}
                >
                  Total Score:
                </Typography>
                <Typography
                  variant="h2"
                  sx={{...( mobileLandscape ? { fontSize: "28px !important ", color: '#fff' , mt:1 } : {    
                    fontWeight: 900,
                    color: '#fff',
                    lineHeight: 1,
                    fontSize: { xs: 24, sm: 44, md: 60 },
                    pb: { xs: 1, md: 1 },
                    pl: { xs: 1, sm:1.2, md: 0 }})
                  }}
                >
                  {location.state?.data?.assessment_type === 'Full Test' ? totalScoreFullTest : totalIndividualScore}
                </Typography>
              </Box>

              <Typography
                variant="body2"
                sx={{
                  ...(mobileLandscape ? { fontSize: "12px !important ", fontWeight: 800, color: '#fff' , mt:1 } : {
                    color: '#fff',
                    fontWeight: 800,
                    fontSize: { xs: 12, sm: 18, md: 16 },
                    pb: { xs: 0, md: 1 },
                    whiteSpace: { xs: 'nowrap', md: 'normal' },
                  })
                }}
              >
                Range: {location.state?.data?.assessment_type === 'Full Test' ? '800 - 1600' : '400 - 800'}
              </Typography>
            </Box>

            <Divider
              sx={{ ...(mobileLandscape ? { borderColor: 'rgba(255,255,255,0.7)', mt:2 , mb:1 } : { borderColor: 'rgba(255,255,255,0.7)', my: { xs: 1.5, md: 2 } }) }}
              orientation="horizontal"
              flexItem
            />
            <Box
              sx={{
                ...(mobileLandscape ? {
                  display: 'flex',
                  alignItems: { xs: 'center', md: 'flex-start' },
                  justifyContent: { xs: 'space-between', md: 'flex-start' },
                  flexDirection: { xs: 'row', md: 'column', lg: 'column' }
                } : { })
              }}>
              <Typography
                variant="body2"
                sx={{
                  ...(mobileLandscape ? { mt: 1, fontSize: "14px !important ", fontWeight: 800, color: '#fff' } : {
                    mt: 1, color: '#fff', fontWeight: 800, fontSize: { xs: 12, sm: 18, md: 16 }
                  })
                }}
              >
                Score Range
              </Typography>

              <Typography
                variant="caption"
                sx={{
                  ...(mobileLandscape ? { fontSize: "10px !important ", fontWeight: 400, color: '#fff', mt: 2, } : {
                    display: 'block', mt: 1, color: '#fff', fontSize: { xs: 10, sm: 16, md: 14 }
                  })
                }}
              >
                This range represents the lowest and highest total scores you could earn based on this assessment
              </Typography>
            </Box>
          </Paper>
        </Grid>
        
       <Grid item xs={12} md={9.5} sx={{ height: '-webkit-fill-available' }}>
          <Card sx={{ ...(mobileLandscape ? { p: 2, marginRight: '1px', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-around' } : {
            p: 2, marginRight: '1px', height: 'inherit', display: 'flex', flexDirection: 'column', justifyContent: 'space-around'}) }} id='card'>
            <Typography variant="h6" 
            sx={{  ...(mobileLandscape ? { fontSize: "14px !important ", fontWeight: 800, color: '#000', mb: 2, } : {
              mb: 2, fontWeight: 700 ,fontSize:{xs: 14 , sm: 26, md: 18}}) }} >Performance Overview</Typography>
            <Grid
              container
              spacing={{ xs: 1.5, sm: 2 }}                              
              sx={{
                alignItems: 'flex-start',
                '& > .statItem': {
                  position: 'relative',
                  borderRight: { md: '1px solid #E5EAF2' },
                  pl: { xs: 1.5, sm: 2 ,md: 0},
                  pt: { xs: 1.5, sm: 2 ,md: 0},
                },
                '& > .statItem:nth-of-type(5n)': {
                  borderRight: { md: 'none' },
                },
              }}
              id="outer-grid"
            >
              <Grid item xs={4} sm={4} md={2.4} className="statItem" id="inner-grid">                  
                <Paper sx={{ p:{ xs: 1, sm:2 , md: 2 }, textAlign: 'left', height: { xs: 'auto', sm: 'auto', md: '100%' } , minHeight: { xs: '110px', sm: '170px', md: '150px' }, display: 'flex', flexDirection: 'column', justifyContent: 'space-around', border: { xs: '1px solid #ccc', sm: '2px solid #ccc', md: '1px solid #fff' } }} elevation={0}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 , minHeight: { xs: 22, sm: 26, md: 24 } }}>
                    <Box sx={{ width: 8, height: 8, backgroundColor: '#4CAF50', borderRadius: '50%' }} />
                    <Typography variant="caption"
                      sx={{
                        ...(mobileLandscape ? { fontSize: "10px !important ", fontWeight: 800, color: '#000' } : {
                          fontWeight: { xs: 500, sm: 500, md: 700 }, fontSize: { xs: '8px', sm: '15px', md: '14px !important' }, xs: '2.4em', sm: '2.8em', md: '2.6em'
                        })
                      }}>Correct Answers</Typography>
                  </Box>
                  <Typography
                    variant="h3"
                    sx={{
                      ...(mobileLandscape ? { fontSize: "26px !important", color: "#102A63", } : {
                        fontWeight: 800,
                        mt: { xs: 1.3, sm: 3, md: 3 },
                        lineHeight: 1,
                        color: "#102A63",
                        fontSize: { xs: "18px", sm: "40px", md: "32px !important" },
                      })
                    }}
                  >
                    {analysisTestScore?.totalCorrectAnswers}
                  </Typography>
                  <Typography variant="caption" sx={{ fontWeight: 500, fontSize: '10px', lineHeight: 1.2, mt: 3, visibility: 'hidden' }} />
                </Paper>
              </Grid>

              <Grid item xs={4} sm={4} md={2.4} className="statItem">
                <Paper sx={{ p:{ xs: 1, sm:2 , md: 2 }, textAlign: 'left', height: { xs: 'auto', sm: 'auto', md: '100%' } , minHeight: { xs: '110px', sm: '170px', md: '150px' }, display: 'flex', flexDirection: 'column', justifyContent: 'space-around', border: { xs: '1px solid #ccc', sm: '2px solid #ccc', md: '1px solid #fff' } }} elevation={0}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 , minHeight: { xs: 22, sm: 26, md: 24 }}}>
                    <Box sx={{ width: 8, height: 8, backgroundColor: '#FF0000', borderRadius: '50%' }} />
                    <Typography variant="caption" 
                      sx={{
                        ...(mobileLandscape ? { fontSize: "10px !important ", fontWeight: 800, color: '#000' } : {
                          fontWeight: { xs: 500, sm: 500, md: 700 }, fontSize: { xs: '8px', sm: '15px', md: '14px !important' }
                        })
                      }}>Incorrect Answers</Typography>
                    <Typography sx={{ visibility: 'hidden' }} />
                  </Box>
                  <Typography
                    variant="h3"
                    sx={{
                      ...(mobileLandscape
                        ? { fontSize: "26px !important", color: "#102A63" }
                        : {
                          fontWeight: 800,
                          mt: { xs: 1.3, sm: 3, md: 3 },
                          lineHeight: 1,
                          color: "#102A63",
                          fontSize: { xs: "18px", sm: "40px", md: "32px !important" },
                        }),
                    }}
                  >
                    {analysisTestScore?.totalIncorrectAnswers}
                  </Typography>
                  <Typography variant="caption" sx={{ fontWeight: 500, fontSize: '10px', lineHeight: 1.2, mt: 3, visibility: 'hidden' }} />
                </Paper>
              </Grid>

              <Grid item xs={4} sm={4} md={2.4} className="statItem">
                <Paper sx={{ p:{ xs: 1, sm:2 , md: 2 }, textAlign: 'left', height: { xs: 'auto', sm: 'auto', md: '100%' } , minHeight: { xs: '110px', sm: '170px', md: '150px' }, display: 'flex', flexDirection: 'column', justifyContent: 'space-around', border: { xs: '1px solid #ccc', sm: '2px solid #ccc', md: '1px solid #fff' } }} elevation={0}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 ,  minHeight: { xs: 20, sm: 26, md: 24 } }}>
                    <Box sx={{ width: 8, height: 8, backgroundColor: '#B3B3B3', borderRadius: '50%' }} />
                    <Typography variant="caption"
                      sx={{
                        ...(mobileLandscape ? { fontSize: "10px !important ", fontWeight: 800, color: '#000', } : {
                          fontWeight: { xs: 500, sm: 500, md: 700 }, fontSize: { xs: '8px', sm: '15px', md: '14px !important' }
                        })
                      }}>Questions Attempted</Typography>
                    <Typography variant="caption" sx={{ fontWeight: 700, visibility: 'hidden' }} />
                  </Box>
                  <Typography
                    variant="h3"
                    sx={{
                      ...(mobileLandscape
                        ? { fontSize: "26px !important", color: "#102A63",  marginBottom: '12px' }
                        : {
                          fontWeight: 800,
                          mt: { xs: 1, sm: 3.4, md: 3 },
                          mb: { xs: 1.2, sm: 0, md: 0 },
                          lineHeight: 1,
                          "@media (min-width:1280px)": { mt: 1 },
                          "@media (min-width:1400px)": { mt: 3 },
                          color: "#102A63",
                          fontSize: { xs: "18px", sm: "40px", md: "32px !important" },
                        })
                    }}
                  >
                    {analysisTestScore?.attemptedQuestions}
                  </Typography>
                  <Typography variant="caption" sx={{ 
                     ...(mobileLandscape
                        ? { fontSize: "8px", color: "#000" }
                        : {
                          fontWeight: 500, fontSize: { xs: 8, sm:14 , md: 14 }, lineHeight: 1.2, mt: { xs: 0.5 ,sm: 3 , md: 3}, '@media (min-width:1400px)': { mt: 1 } })
                          }}>
                    (Out of {analysisTestScore?.totalQuestions} Questions)
                  </Typography>
                </Paper>
              </Grid>

              <Grid item xs={4} sm={4} md={2.4} className="statItem">
                <Paper sx={{ p:{ xs: 1, sm:2 , md: 2 }, textAlign: 'left', height: { xs: 'auto', sm: 'auto', md: '100%' } , minHeight: { xs: '110px', sm: '170px', md: '150px' }, display: 'flex', flexDirection: 'column', justifyContent: 'space-around', border: { xs: '1px solid #ccc', sm: '2px solid #ccc', md: '1px solid #fff' } }} elevation={0}>
                  <Typography variant="caption" 
                  sx={{  ...(mobileLandscape ? { fontSize: "10px !important ", fontWeight: 800, color: '#000' } : {
                    fontWeight:  {xs: 500, sm: 500, md: 700}, fontSize: {xs:'8px', sm:'15px', md:'14px !important'} })
                    }}>Overall Accuracy</Typography>
                  <Typography variant="caption" sx={{ fontWeight: 700, visibility: 'hidden' }} />
                  <Typography
                    variant="h3"
                    sx={{
                      ...(mobileLandscape
                        ? { fontSize: "26px !important", color: "#102A63" }
                        : {
                          fontWeight: 800,
                          mt: 3.2,
                          lineHeight: 1,
                          color: "#102A63",
                          fontSize: { xs: "18px", sm: "40px", md: "32px !important" },
                        }),
                    }}
                  >
                    {analysisTestScore?.overallAccuracy}%
                  </Typography>
                  <Typography variant="caption" sx={{ lineHeight: 1.2, mt: 3, visibility: 'hidden' }} />
                </Paper>
              </Grid>

              <Grid item xs={4} sm={4} md={2.4} className="statItem">
                <Paper sx={{ p: { xs: 1, sm: 2, md: 2 }, textAlign: 'left', height: { xs: 'auto', sm: 'auto', md: '100%' }, minHeight: { xs: '110px', sm: '170px', md: '150px' }, display: 'flex', flexDirection: 'column', justifyContent: 'space-around', border: { xs: '1px solid #ccc', sm: '2px solid #ccc', md: '1px solid #fff' } }} elevation={0}>
                  <Typography variant="caption" 
                  sx={{  ...(mobileLandscape ? { fontSize: "10px !important ", fontWeight: 800, color: '#000' } : {
                    fontWeight: { xs: 500, sm: 500, md: 700 }, fontSize: { xs: '8px', sm: '15px', md: '14px !important' } })
                    }}>Time Spent Per Question</Typography>
                  <Typography
                    variant="h3"
                    sx={{
                      ...(mobileLandscape
                        ? { fontSize: "26px !important", color: "#102A63",  marginBottom: '8px' }
                        : {
                          fontWeight: 800,
                          mt: 1.2,
                          lineHeight: 1,
                          "@media (min-width:1400px)": { mt: 3 },
                          color: "#102A63",
                          fontSize: { xs: "18px", sm: "40px", md: "32px !important" },
                        }),
                    }}
                  >
                    {analysisTestScore?.averageTime}s
                  </Typography>
                  <Typography variant="caption" sx={{ lineHeight: 1.2, mt: 3, visibility: 'hidden' }} />
                </Paper>
              </Grid>
            </Grid>

            <Grid container spacing={1} sx={{ mt: 3 }}>
              <Divider orientation="horizontal" flexItem />
              <Grid item xs={12} sx={{ borderTop:'1px solid #ccc' }}>
                <Typography variant="body2" sx={{...(mobileLandscape ? { fontSize: "12px !important ", fontWeight: 800, color: '#000' } : { mb: 0.5, mt: 0.5, fontWeight: 500 , fontSize:{ xs: 12, sm: 22, md: 22 }} )}}>Improvement Tips: </Typography>
                <Typography variant="body2" sx={{...(mobileLandscape ? { fontSize: "10px !important ", fontWeight: 800, color: '#000' } : { mb: 1, fontWeight: 500  , fontSize:{ xs: 10, sm: 16, md: 16 }} )}}>Steady effort makes the difference. Continue completing practice tests to move toward your ideal SAT score</Typography>
              </Grid>
            </Grid>
          </Card>
          {/* <Divider orientation="horizontal" flexItem /> */}
        </Grid>
        {/* <Grid item xs={12} md={2.5} pt={2} sx={{ height: '-webkit-fill-available', }}>
          <Box sx={{height: 'inherit', border: '2px solid #9ebbfd', padding: '16px !important', borderRadius: '6px', backgroundColor: '#E9EFFD',
            display: 'flex', flexDirection: 'column', justifyContent: 'space-around'}}>
            <Typography variant='h6' sx={{color: '#1b5ab2'}}>Download Your Test Report PDF for Later</Typography>
             <Typography variant='body2' sx={{color: '#111'}}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard</Typography>
            <Button variant="contained" startIcon={<GetAppIcon />} sx={{ bgcolor: '#1f4ed8', textTransform: 'none' , borderRadius: '4px'}}>Download</Button>
          </Box>
        </Grid> */}
      </Grid>

    );
  };


  const statusColors = {
    correct: "#4caf50",
    wrong: "#f44336",
    unattempted: "transparent",
  };



  const QuestionBox = ({ num, status }) => (
    <Box
      sx={{
        width: 32,
        height: 32,
        borderRadius: "6px",
        border: status === "unattempted" ? "1px dashed #999" : "none",
        backgroundColor: statusColors[status],
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: status === "unattempted" ? "#333" : "#fff",
        fontSize: "14px",
        fontWeight: 500,
      }}
    >
      {num}
    </Box>
  );

  // eslint-disable-next-line arrow-body-style
  const SquaresRow = ({ filled, color }) => {
    return (
      <Box display="flex" gap={1}>
        {Array.from({ length: 7 }).map((_, idx) => (
          <Box
            key={idx}
            sx={{
              width: 35,
              height: 35,
              borderRadius: "4px",
              backgroundColor: idx < filled ? color : "#e0e0e0",
            }}
          />
        ))}
      </Box>
    );
  };

  // eslint-disable-next-line arrow-body-style
  const SectionSummary = ({ title, score, detailsLeft, detailsRight, detailsAccuracy, topicNumber, onViewSolutions }) => {
    return (
      <Paper sx={{ p: '16px 0px 0 16px', borderRadius: 2 , border:'2px solid #eee'}} elevation={0}>
        <Grid container spacing={2} padding={2} >
          <Box sx={{ display: 'flex', gap: 1, marginBottom: '5px', justifyContent:'center', alignContent:'center' }}>
            <Box sx={{ bgcolor: '#eeeeee', p: 2, borderRadius: 1, width: '24px', height: '24px', textAlign: 'center', fontSize:'14px' }}>{topicNumber}</Box>
            <Typography variant="subtitle2" sx={{ color: '#111',  fontSize:{xs:'12px', sm:'18px', md:'18px'} , alignSelf:'top' }}>{title}</Typography>
          </Box>
          <Grid container xs={12} md={12} sx={{ mt: 1 }}>
            <Grid item xs={12} md={4} >
              <Box sx={{
                bgcolor: {xs:'#fff', sm: '#fff' , md: '#eee'}, padding: '12px !important', borderRadius: 1, marginRight: "10px", height: "-webkit-fill-available",
                display: 'flex', flexDirection: 'column', justifyContent: 'space-around'
              }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: { xs: 'baseline', md: 'flex-start' },
                    justifyContent: { xs: 'space-between', md: 'flex-start' },
                    gap: { xs: 1.5, md: 0.5 },
                    flexDirection: { xs: 'row', md: 'column', lg: 'column' },
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: { xs: 'baseline', sm:'center' , md: 'flex-start' },
                      justifyContent: { xs: 'space-between', sm:'center' , md: 'flex-start' },
                      flexDirection: { xs: 'row', md: 'column', lg: 'column' },
                    }}>
                    <Typography variant="subtitle2" sx={{
                      ...(mobileLandscape
                        ? { fontSize: "12px !important", color: '#000', marginBottom: '12px' }
                        : {
                          color: '#000', fontSize: '12px'
                        })
                    }}>Section Score</Typography>
                    <Typography variant="h5" sx={{ fontWeight: 800 , ml:{ xs: 1 , sm: 1, md: 0 } , fontSize:{xs:'20px', sm:'30px', md:'20px'} }}>{score}</Typography>
                  </Box>

                  <Typography variant="subtitle2" sx={{
                    ...(mobileLandscape
                      ? { fontSize: "12px !important", color: '#000', }
                      : { color: '#000', fontSize:'12px'})
                  }}>Range: {location.state?.data?.assessment_type === 'Full Test' ? '400 - 800' : '200 - 400'}</Typography>
                </Box>
               
                <Divider sx={{ my: 1 , mb:2 }} />
                <Box textAlign='center' display={{xs:'none', sm:'none', md:'block'}}>
                  {location.state?.data?.assessment_type !== 'Full Test' && location.state?.data?.data?.type !== "Chapter" &&
                    <Button size="small" variant='contained' sx={{
                      textTransform: 'none', border: '2px solid #83a7fa', background: 'none', color: "#83a7fa", borderRadius: '4px',
                      '&:hover': { border: '2px solid #83a7fa', color: '#fff !important', backgroundColor: '#83a7fa' },
                    }} onClick={onViewSolutions}>View Solutions</Button>}
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={8}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Paper
                    sx={{...(mobileLandscape ? {  p: 1.5, display: "grid", gap : 1.4, gridTemplateColumns:'60px 1fr auto',  alignItems: "center", background: "#eee"} : {  
                      p: 1.5,
                      background: "#eee",
                      borderLeft: "3px solid #88ebb2",
                      display: "grid",
                      gridTemplateColumns: {
                        xs: '75px 1fr auto',        
                        sm: '120px 1fr auto', 
                        md: '120px 1fr auto', 
                      },
                      alignItems: "center",
                      borderRadius: "8px",
                      height: 55,
                    })
                    }}
                    elevation={0}
                  >
                    <Typography variant="h6" sx={{ ...(mobileLandscape ? { fontWeight: 700 , fontSize:'14px !important' } : { 
                      fontWeight: 700 , fontSize:{xs:'12px', sm:'22px', md:'18px'}})}}>
                      {detailsLeft.correct}
                    </Typography>
                    <Typography variant="body2" sx={{
                       ...(mobileLandscape ? { fontWeight: 700 , fontSize:'12px !important' } : {  fontWeight: 600 , fontSize:{xs:'12px', sm:'18px', md:' 14px'}}) }}>
                      Correct
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{  ...(mobileLandscape ? { fontSize:'12px !important', textAlign: "right" } : { fontWeight: 500, color: "#555", textAlign: "right" , fontSize:{xs:'12px', sm:'16px', md:'14px'}})}}
                    >
                      {detailsLeft.notes}
                    </Typography>
                  </Paper>
                </Grid>

                <Grid item xs={12}>
                  <Paper
                    sx={{...(mobileLandscape ? {  p: 1.5, display: "grid", gap : 1.4, gridTemplateColumns:'60px 1fr auto',  alignItems: "center", background: "#eee"} : {  
                      p: 1.5,
                      background: "#eee",
                      borderLeft: "3px solid #fcb3ba",
                      display: "grid",
                      gridTemplateColumns: {
                        xs: '75px 1fr auto',       
                        sm: '120px 1fr auto', 
                        md: '120px 1fr auto', 
                      },
                      alignItems: "center",
                      borderRadius: "8px",
                      height: 55,
                    })
                    }}
                    elevation={0}
                  >
                    <Typography variant="h6" sx={{ ...(mobileLandscape ? { fontWeight: 700 , fontSize:'14px !important' } : { 
                      fontWeight: 700 , fontSize:{xs:'12px', sm:'22px', md:'18px'}})}}>
                      {detailsRight.incorrect}
                    </Typography>
                    <Typography variant="body2" sx={{
                       ...(mobileLandscape ? { fontWeight: 700 , fontSize:'12px !important' } : {  fontWeight: 600 , fontSize:{xs:'12px', sm:'18px', md:' 14px'}}) }}>
                      Incorrect
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{  ...(mobileLandscape ? { fontSize:'12px !important', textAlign: "right" } : { fontWeight: 500, color: "#555", textAlign: "right" , fontSize:{xs:'12px', sm:'16px', md:'14px'}})}}
                    >
                      {detailsRight.notes}
                    </Typography>
                  </Paper>
                </Grid>

                <Grid item xs={12}>
                  <Paper
                    sx={{  ...(mobileLandscape ? {  p: 1.5, display: "grid", gap : 1.4, gridTemplateColumns:'60px 1fr auto',  alignItems: "center", background: "#eee"} : {     
                      p: 1.5,
                      background: "#eee",
                      borderLeft: "3px solid #86aaff",
                      display: "grid",
                      gridTemplateColumns: {
                        xs: '75px 1fr auto',       
                        sm: '120px 1fr auto', 
                        md: '120px 1fr auto',  
                      },
                      alignItems: "center",
                      borderRadius: "8px",
                      height: 55,
                    })
                    }}
                    elevation={0}
                  >
                    <Typography variant="h6" sx={{ ...(mobileLandscape ? { fontWeight: 700 , fontSize:'14px !important' } : { 
                      fontWeight: 700 , fontSize:{xs:'12px', sm:'22px', md:'18px'}})}}>
                      {Number.isNaN(detailsAccuracy.accuracy) ||  analysisTestScore?.attemptedQuestions === 0 ? '0%' : `${detailsAccuracy?.accuracy}`}
                    </Typography>
                    <Typography variant="body2" sx={{
                       ...(mobileLandscape ? { fontWeight: 700 , fontSize:'12px !important' } : {  fontWeight: 600 , fontSize:{xs:'12px', sm:'18px', md:' 14px'}}) }}>
                      Accuracy
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{  ...(mobileLandscape ? { fontSize:'12px !important', textAlign: "right" } : { fontWeight: 500, color: "#555", textAlign: "right" , fontSize:{xs:'12px', sm:'16px', md:'14px'}})}}
                    >
                      {detailsAccuracy.notes}
                    </Typography>
                  </Paper>
                </Grid>
                <Box textAlign='center' display={{xs:'block', sm:'block', md:'none'}} sx={{ display: { xs: 'block', sm: 'block', md: 'none' }, mt: 2, ml: 1, width: '100%' }}>
                  {location.state?.data?.assessment_type !== 'Full Test' && location.state?.data?.data?.type !== "Chapter" &&
                    <Button size="small" fullWidth variant='contained' sx={{
                      textTransform: 'none', border: '2px solid #83a7fa', background: 'none', color: "#83a7fa", borderRadius: '4px',
                      '&:hover': { border: '2px solid #83a7fa', color: '#fff !important', backgroundColor: '#83a7fa'},
                    }} onClick={onViewSolutions}>View Solutions</Button>}
                </Box>
              </Grid>
            </Grid>
            <Divider orientation="horizontal" flexItem />
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box sx={{ mt: 1 }}>
                  {/* <Grid container spacing={1}>
                  {[...Array(12)].map((_, i) => (
                    <Grid item key={i} xs={1} sx={{ display: 'flex', justifyContent: 'center' }}>
                      <Box> ABC </Box>
                    </Grid>
                  ))}
                </Grid> */}
                  {/* <Box sx={{ maxWidth: 700, margin: "20px auto" }}>
                <Grid container spacing={3}>
                    {sections.map((section, idx) => (
                    <Grid item xs={12} key={idx}>
                        <Box display="flex" alignItems="center" justifyContent="space-between" sx={{flexDirection: { xs: 'column', sm: 'row', md: 'row'} , alignItems: {xs: 'start', sm: 'center'}}}>
                        <Box>
                            <Typography variant="subtitle1" fontWeight="bold">
                            {section.title}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                            {section.subtitle}
                            </Typography>
                        </Box>
                        <SquaresRow filled={section.filled} color={section.color} />
                        </Box>
                    </Grid>
                    ))}
                </Grid> 
                </Box>
                {/* <Box sx={{ mt: 2, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                  <Button size="small" variant="outlined" sx={{ textTransform: 'none', borderRadius: '4px', width: '100%', color: '#83a7fa', border: '2px solid #83a7fa',
                      '&:hover': {border: '2px solid #83a7fa', color: '#fff !important', backgroundColor: '#83a7fa'},
                   }}>Practice this Section</Button>
                </Box> */}
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    );
  };

  const QuestionWiseAnalysis = () => {

    const [expanded, setExpanded] = useState(null);

    const handleAccordionChange = (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : null);
    };

    useLayoutEffect(() => {
      const savedScrollPosition = sessionStorage.getItem('scrollPosition');
      if (savedScrollPosition) {
        window.scrollTo(0, parseInt(savedScrollPosition, 10));
      }
    }, [activeTabs]);


    useEffect(() => {
      const handleScroll = () => {
        sessionStorage.setItem('scrollPosition', window.scrollY);
      };
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const isPassageVisible =
      ((location.state?.data?.assessment_type === 'English Subject Test' && location.state?.data?.assessment_type === 'English Subject Test') ||
        (location.state?.data?.assessment_type === 'Full Test' && (activeTabs === "rw1" || activeTabs === "rw2")))


    return (
      <>
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 , fontSize:{xs:'14px', sm:'26px', md:'26px'}}}>
          Question-wise Analysis
        </Typography>

        {/* <Tabs
          value={activeTabs}
          onChange={handleTabChangeTabs}
          id="tabSwitcher"
          variant={visibleTabs?.length >= 2 ? "fullWidth" : "standard"}
          sx={{
            borderBottom: '1px solid #ddd',
            minHeight: 35,
            '& .MuiTabs-indicator': {
              height: 3,
              borderRadius: 3,
              backgroundColor: '#f0f4ff', 
            },
            '& .MuiTabs-scroller': {
              overflowX: { xs: 'auto !important', md: 'hidden' },
              '&::-webkit-scrollbar': { height: 6 },
              '&::-webkit-scrollbar-track': { backgroundColor: '#edededff' },
              '&::-webkit-scrollbar-thumb': { backgroundColor: '#dfdfdfff', borderRadius: 8 },
            },
            '& .MuiTabs-flexContainer': {
              width: { xs: 'max-content', md: '100%' },
              display: 'flex',
            },

            
          }}
        >
          {visibleTabs?.map((tab) => (
            <Tab
              key={tab.id}
              value={tab.id}
              label={tab.label}
              sx={{
                textTransform: 'none',
                minHeight: 48,
                padding:{ xs: '8px 10px', sm: '10px 12px', md:'10px 12px'},
                minWidth: { xs: 0, sm:0, md: 0 },
                flexBasis: {  xs: visibleTabs?.length === 2 ? '50%' : '25%' , sm : visibleTabs?.length === 2 ? '50%' : '25%' , md: visibleTabs?.length === 2 ? '50%' : '25%' },
                flexGrow: { md: 1 },
                maxWidth: { md: 'none' },
                fontWeight: 600,
                fontSize: { xs: 10, sm: 13, md: 14 },
                color: activeTabs === tab.id ? '#3d88fa !important' : '#000', 
                background: activeTabs === tab.id ? '#f0f4ff' : '#fff',
                borderBottom: activeTabs === tab.id ? '2px solid #3d88fa !important' : 'none', 
                '& .MuiTab-wrapper': {
                  whiteSpace: { xs: visibleTabs?.length === 2 ? 'nowrap' : 'normal', sm: 'nowrap', md: 'nowrap' },
                  display: { xs: '-webkit-box', sm: 'block', md: 'block' },
                  WebkitLineClamp: { xs: 2, sm: 'unset', md: 'unset' },
                  WebkitBoxOrient: { xs: 'vertical', sm: 'unset', md: 'unset' },
                  lineHeight: 1.2,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxHeight: { xs: '2.4em', sm: 'unset', md: 'unset' },
                },
            }}
            />
          ))}
        </Tabs> */}

        <Tabs
          value={activeTabs}
          onChange={handleTabChangeTabs}
          id="tabSwitcher"
          variant={visibleTabs?.length >= 2 ? "fullWidth" : "standard"}
          sx={{
            borderBottom: '1px solid #ddd',
            minHeight: 35,
            '& .MuiTabs-indicator': {
              height: 3,
              borderRadius: 3,
              backgroundColor: '#f0f4ff',
            },
            '& .MuiTabs-scroller': {
              overflowX: {
                xs: visibleTabs?.length === 2 ? 'hidden !important' : 'auto !important',
                sm: 'auto !important',
                md: 'hidden',
              },
              scrollbarWidth: visibleTabs?.length === 2 ? 'none' : 'thin',
              '&::-webkit-scrollbar': {
                display: visibleTabs?.length === 2 ? 'none' : 'block',
                height: 6,
              },
              '&::-webkit-scrollbar-track': { backgroundColor: '#edededff' },
              '&::-webkit-scrollbar-thumb': { backgroundColor: '#dfdfdfff', borderRadius: 8 },
            },
            '& .MuiTabs-flexContainer': {
              width: { xs: visibleTabs?.length === 2 ? '100%' : 'max-content', sm:'100%', md: '100%' },
              display: 'flex',
            },
          }}
        >

          {visibleTabs?.map((tab) => (
            <Tab
              key={tab.id}
              value={tab.id}
              label={tab.label}
              sx={{
                textTransform: 'none',
                minHeight: 48,
                padding: { xs: '8px 10px', sm: '10px 12px', md: '10px 12px' },
                minWidth: 0,
                flexBasis: {
                  xs: visibleTabs?.length === 2 ? '50%' : 'auto',
                  sm: visibleTabs?.length === 2 ? '50%' : 'auto',
                  md: visibleTabs?.length === 2 ? '50%' : '25%',
                },
                flexShrink: 0,
                fontWeight: 600,
                fontSize: { xs: 10, sm: 13, md: 14 },
                color: activeTabs === tab.id ? '#3d88fa !important' : '#000',
                background: activeTabs === tab.id ? '#f0f4ff' : '#fff',
                borderBottom: activeTabs === tab.id ? '2px solid #3d88fa !important' : 'none',

                '& .MuiTab-wrapper': {
                  whiteSpace: {
                    xs: visibleTabs?.length > 2 ? 'normal' : 'nowrap',
                    sm: 'nowrap',
                    md: 'nowrap',
                  },
                  lineHeight: 1.2,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: { xs: '-webkit-box', sm: 'block', md: 'block' },
                  WebkitLineClamp: { xs: visibleTabs?.length > 2 ? 2 : 'unset', sm: 'unset', md: 'unset' },
                  WebkitBoxOrient: { xs: 'vertical', sm: 'unset', md: 'unset' },
                  maxHeight: { xs: visibleTabs?.length > 2 ? '2.4em' : 'unset', sm: 'unset', md: 'unset' },
                },
              }}
            />
          ))}
        </Tabs>

        <Box sx={{ mt: 4 }}>

          {allQuestions && allQuestions?.length > 0 && allQuestions.map((question, index) => (
            <Card
              key={question.id}
              sx={{
                borderRadius: 1,
                boxShadow: "none",
                border: "1px solid #e0e0e0",
                mb: 2,
                overflow: "hidden",
                background: "#fff",
              }}
            >
              <Accordion
                expanded={expanded === question.id}
                // onChange={handleAccordionChange(question.id)}
                sx={{
                  "&:before": { display: "none" },
                  boxShadow: "none",
                }}
              >
                <AccordionSummary
                  sx={{
                    backgroundColor: "#ffffff",
                    p:{xs:'2px 8px 2px 8px', sm:2, md:2} ,
                    "& .MuiAccordionSummary-content": {
                      display: "flex",
                      flexDirection:{xs:'row', sm:'row', md:'row'},
                      alignItems: "center",
                      justifyContent: {xs:'flex-start', sm:'flex-start', md:'flex-start'},
                      flexWrap: "wrap",
                      gap: { xs: 1, sm: 2, md: 3 },
                      minWidth: 0,
                    },
                  }}
                >
                  <Box sx={{ // index + 1
                    display: "flex", alignItems: "center", width: 25, height:28, justifyContent: "center", gap: 0.5,
                    backgroundColor: "#E9EFFD",borderRadius:{xs:'4px', sm:'4px', md:'4px'},alignSelf:'baseline',
                    // color: question.userResponse === "correct" ? "#2e7d32" : question.userResponse === null ? "#757575" : "#d32f2f",
                    p:1.2, fontSize: { xs: 10 , sm: 13 , md: 13}, fontWeight: 600, textTransform: "capitalize",
                  }} >
                    {index + 1}
                  </Box>
                  <Box sx={{display:'flex', flexDirection:{xs:'column', sm:'column', md:'row'},  flex: 1, justifyContent: {xs:'flex-start', sm:'flex-start', md:'space-around'},alignItems: {md:'baseline'}, gap:{ xs: 2 , sm: 2 , md: 5 } }}>

                 
                  <Box sx={{  // Correct , Not Answered , Incorrect
                    display: "flex", alignItems: "center", width:{ xs : 100 , sm : 130 , md : 130 }, height:30,justifyContent: "center", gap: 0.5,
                    backgroundColor: question.userResponse === "correct" ? "#e8f5e9" : question.userResponse === null ? "#e3e8ef" : "#ffebee",
                    color: question.userResponse === "correct" ? "#2e7d32" : question.userResponse === null ? "#3F3F3F" : "#d32f2f",
                    px: 1.2, py: 3, borderRadius: {xs:'4px', sm:'4px', md:'4px'}, fontSize:{xs:9, sm:14, md:14}, fontWeight: 600, textTransform: "capitalize",
                  }} >
                     {question.userResponse === "correct"
                      ? "Correct"
                      : question.userResponse === null
                        ? "Not Answered"
                        : "Incorrect"}
                    {question.userResponse === "correct" ? (
                      <DoneIcon sx={{ fontSize: 16 }} />
                    ) : question.userResponse === null ? (
                     <Typography sx={{ fontSize: 18 , color:'#3F3F3F'}}>!</Typography>
                    ) : (
                      <CloseIcon sx={{ fontSize: 16 }} />
                    )}
                   
                  </Box>

                    <Box id='123' sx={{ // 3 typography
                      ...(mobileLandscape
                        ? {
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          columnGap: 2,
                          rowGap: 1,
                          flex: 1,
                          minWidth: 0,
                          flexWrap: "wrap",
                        }
                        : {
                      display: "flex",
                      flexDirection: { xs: "row", sm: "row", md: "row" },
                      justifyContent: { xs: "flex-start", sm: "flex-start", md: "flex-start" },
                      alignItems: "center",
                      columnGap: { xs: 2, sm: 4, md: 6 },
                      rowGap: 1,
                      flex: 1,            
                      minWidth: 0,
                      flexWrap: "wrap",})
                    }}>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: 'black' , fontSize:{ xs: 9 , sm: 16 , md: 14} }}>{/* Time spent:  */}
                      Time spent: {question?.timetaken ? question.timetaken.toFixed(1) : "0.0"} s
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: 'black' , fontSize:{ xs: 9 , sm: 16 , md: 14}  }}> {/* Selected option: */}
                      Selected option:{" "}
                      <Box component="span" sx={{ fontWeight: 600, color: 'inherit' }}>
                        {(() => {
                          try {
                            const parsedAnswer =
                              typeof question.answer === "string"
                                ? JSON.parse(question.answer)
                                : question.answer || {};

                            const options = Array.isArray(parsedAnswer?.mcqOptions)
                              ? parsedAnswer.mcqOptions
                              : [];

                            let selected = question.selectedAnswer;

                            if (typeof selected === "string") {
                              try {
                                const parsed = JSON.parse(selected);
                                if (Array.isArray(parsed)) selected = parsed[0];
                                else if (typeof parsed === "object" && parsed !== null)
                                  selected = parsed.value || parsed.option || "";
                                else selected = parsed;
                              } catch {
                                // Not JSON, keep as-is
                              }
                            }

                            const normalize = (str) => {
                              if (!str) return "";
                              return str
                                .toString()
                                .replace(/<[^>]+>/g, "")
                                .replace(/&nbsp;/g, " ")
                                .trim()
                                .toLowerCase();
                            };

                            const normalizedSelected = normalize(selected);

                            const selectedIndex = options.findIndex(
                              (opt) => normalize(opt) === normalizedSelected
                            );

                            const selectedLabel =
                              selectedIndex !== -1 ? String.fromCharCode(65 + selectedIndex) : "-";

                            return selectedLabel ? `${selectedLabel}` : "-";
                          } catch (err) {
                            return "-";
                          }
                        })()}
                      </Box>


                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: 'black' , fontSize:{ xs: 9 , sm: 16 , md: 14} }}> {/* correct answer */}
                      Correct answer:{" "}
                      <Box component="span" sx={{ fontWeight: 600, color: 'inherit' }}>
                        {(() => {
                          const parsedAnswer =
                            typeof question.answer === "string"
                              ? JSON.parse(question.answer)
                              : question.answer;

                          const options = parsedAnswer?.mcqOptions || [];
                          const correctAnswers = parsedAnswer?.correctAnswer || [];
                          const correctIndex = correctAnswers.findIndex((ans) => ans === true);
                          const correctLabel =
                            correctIndex !== -1 ? String.fromCharCode(65 + correctIndex) : "";

                          return (
                            <>
                              {correctLabel && `${correctLabel} `}
                            </>
                          );
                        })()}
                      </Box>
                    </Typography>
                  </Box>

                  <Button //  View Question and Explanation 
                    size="small"
                    sx={{
                      color: "#000000ff",
                      textTransform: "none",
                      fontWeight: 500,
                      fontSize:{xs:9, sm:14, md:14} ,
                      borderRadius: {xs:'4px', sm:'4px', md:'4px'},
                      background: '#eee',
                      '&:hover': { background: '#eee' },
                      width: { xs: '100%', sm: 'auto' },
                      maxWidth: { xs: 180, sm: 280, md: 'unset' },
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      ml: { xs: 0, sm: 0},
                      mt: { xs: 0, sm: 0 },
                      order: { xs: 2, sm: 0 },         
                      alignSelf: { xs: 'flex-start', sm: 'flex-start' },
                      pl:{ xs: 0.5 , sm: 3 , md: 3},
                      pr:{ xs: 0.5 , sm: 3 , md: 3}
                    }}
                     endIcon={<ExpandMoreIcon sx={{ fontSize: 30 }} />}
                     onClick={() => setExpanded(expanded === question.id ? null : question.id)}
                  >
                    {expanded === question.id
                      ? "Hide Question and Explanation"
                      : "View Question and Explanation"}
                  </Button>
                  </Box>
                </AccordionSummary>


                <AccordionDetails id='accordian'
                  sx={{
                    backgroundColor: expanded === question.id ? '#eee' : '#fff',
                    p:{xs:1.5, sm:3 ,md:3},
                    border:{xs:'8px solid #fff' , sm: '20px solid #fff' , md: '20px solid #fff'},
                    borderRadius:{ xs: 2 , sm: 3.5 , md: 4}
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: isPassageVisible
                        ? { xs: 'column', md: 'column' }
                        : { xs: 'column', md: 'row' },
                      alignItems: 'flex-start',
                      gap: 2,
                      width: '100%',
                    }}
                  >
                    <Box id='boxPassage1'
                      sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: isPassageVisible ? {xs:'column',sm:'column',md:'row'} : {xs:'column',sm:'column',md:'column'},
                        pr: !isPassageVisible ? { md: 2 } : 0,
                        minWidth: 0,
                        width: isPassageVisible ? '100%' : '100%'
                      }}
                    >
                      {isPassageVisible && question?.passage && (
                        <>
                          <Box sx={{ flex: 1 }} id='boxPassage2'>
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: 600, mb: 1, color: '#000' }}
                            >
                              PASSAGE:
                            </Typography>
                            <Typography
                              dangerouslySetInnerHTML={{ __html: question?.passage }}
                              variant="body2"
                              sx={{
                                lineHeight: 1.7, color: '#555', fontSize: { xs: 12, sm: 14, md: 14 }, wordBreak: "break-word",
                                "& ul, & ol": { paddingLeft: "20px" },
                                "& li": { marginBottom: "4px" }
                              }}
                            />
                          </Box>

                          <Divider
                            orientation="vertical"
                            flexItem
                            sx={{
                              borderColor: '#ccc',
                              display: { xs: 'none', md: 'block' },
                              mx: 1,
                            }}
                          />
                        </>
                      )}

                      <Divider
                        orientation="horizontal"
                        sx={{
                          borderColor: '#ddd',
                          display: isPassageVisible ? { xs: 'block', md: 'none' }:{ xs: 'none', md: 'none' },
                          my: 2,
                        }}
                      />

                      <Box id='questionBox'
                        sx={{
                          flex: !isPassageVisible ? 1 : 'unset',
                          width: isPassageVisible ?  {xs:'100%', sm:'100%', md:'50%'} :{ xs:'100%', sm:'100%', md:'100%'},
                          pr: !isPassageVisible ? { md: 2 } : 0,
                          minWidth: 0,
                          ml:{xs:0 , sm:0 , md:1 }
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{ mb: 1,mt:1, fontWeight: 600, color: '#000' }}
                        >
                          QUESTION:
                        </Typography>

                        <Typography
                          variant="body2"
                          sx={{
                            mb: 3, lineHeight: 1.7, color: '#333', fontSize: { xs: 12, sm: 14, md: 14 }, wordBreak: "break-word",
                            "& ul, & ol": { paddingLeft: "20px" },
                            "& li": { marginBottom: "4px" }
                          }}
                          dangerouslySetInnerHTML={{ __html: question?.question_text }}
                        />

                        <Grid container spacing={1.5} sx={{ mb: 3, flexDirection: 'column' }}>
                          {(() => {
                            const parsedAnswer =
                              typeof question.answer === 'string'
                                ? JSON.parse(question.answer)
                                : question.answer;
                            const options = parsedAnswer?.mcqOptions || [];
                            const correctAnswers = parsedAnswer?.correctAnswer || [];

                            return options.map((value, index) => {
                              const key = String.fromCharCode(65 + index);
                              const isCorrect = correctAnswers[index] === true;
                              const isSelected = question.selectedAnswer === value;
                              const isWrong = isSelected && !isCorrect;

                              return (
                                <Grid item xs={12} key={key}>
                                  <Box
                                    sx={{
                                      borderRadius: '8px',
                                      border: isWrong
                                        ? '1.8px solid #d32f2f'
                                        : isCorrect
                                          ? '1.8px solid #2e7d32'
                                          : '1px solid #000',
                                      p: 1.8,
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                      backgroundColor: isCorrect
                                        ? '#e8f5e9'
                                        : isWrong
                                          ? '#ffebee'
                                          : '#eee',
                                      color: isCorrect
                                        ? '#000'
                                        : isWrong
                                          ? '#000'
                                          : '#000',
                                      transition: 'all 0.2s ease',
                                      borderBottom: isCorrect
                                        ? '1.8px solid #2e7d32 !important'
                                        : isWrong
                                          ? '1.8px solid #d32f2f !important'
                                          : '1px solid #000 !important',
                                    }}
                                  >
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        p: 1,
                                        fontWeight: 500,
                                        display: 'flex',
                                        alignItems: 'center',
                                        fontSize: { xs: 12, sm: 14, md: 14 },
                                        "& ul": { listStyle: "none" },
                                        "& ol": { listStyle: "none" },
                                        "& li": { listStyle: "none" },
                                      }}
                                    >
                                      <Box sx={{
                                        width: {xs:20,sm:24,md:28}, height: {xs:20,sm:24,md:28}, minWidth: {xs:20,sm:24,md:28}, minHeight: {xs:20,sm:24,md:28}, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 500, fontSize: {xs:10,sm:14,md:14}, borderRadius: '50%',
                                        border: isCorrect ? '2px solid #249935' : isWrong ? '2px solid #B50000' : '1px solid #000',
                                        backgroundColor: isCorrect ? '#249935' : isWrong ? '#B50000' : '#F4F4F4',
                                        color: isCorrect ? '#fff' : isWrong ? '#fff' : '#000', transition: 'all 0.2s', marginRight: 1.5, mb: '2px'
                                      }} >
                                        {key}
                                      </Box>
                                      <span dangerouslySetInnerHTML={{ __html: value }} />
                                    </Typography>

                                    {isCorrect && (
                                      <DoneIcon
                                        sx={{ color: '#2e7d32', marginRight: '10px' }}
                                      />
                                    )}
                                    {isWrong && (
                                      <CloseIcon sx={{ color: '#d32f2f', marginRight: '10px' }} />
                                    )}
                                  </Box>
                                </Grid>
                              );
                            });
                          })()}
                        </Grid>
                      </Box>
                    </Box>

                    <Divider
                      sx={{
                        borderBottomWidth: 'thin',
                        borderColor: '#ccc',
                        marginTop: '0px',
                        marginBottom: '14px',
                      }}
                      orientation="horizontal"
                      flexItem
                    />

                    {!isPassageVisible && (
                      <Divider
                        orientation="vertical"
                        flexItem
                        sx={{
                          display: { xs: 'none', md: 'block' },
                          borderColor: '#e0e0e0',
                          mx: 0,
                          my: 0,
                        }}
                      />
                    )}

                    {/* Explanation Section */}
                    <Box
                      sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        pl: !isPassageVisible ? { md: 2 } : 0,
                        minWidth: 0,
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: 600, mb: 1, color: '#143681' }}
                      >
                        EXPLANATION:
                      </Typography>

                      <Typography
                        variant="body2"
                        sx={{
                          lineHeight: 1.7, color: '#555', fontSize: { xs: 12, sm: 14, md: 14 }, wordBreak: "break-word",
                          "& ul, & ol": { paddingLeft: "20px" },
                          "& li": { marginBottom: "4px" }
                        }}
                        dangerouslySetInnerHTML={{ __html: question?.justification }}
                      />
                    </Box>
                  </Box>
                </AccordionDetails>




              </Accordion>
            </Card>
          ))}
        </Box>
      </>
    );
  };



  // eslint-disable-next-line arrow-body-style
  const ViewReportPage = () => {
    return (
      <>
        <Box sx={{ mb: 3 }}>

          <Breadcrumbs
            aria-label="breadcrumb"
            sx={{
              padding: '15px',
              paddingLeft: '0px',
              paddingBottom: '0px',
              paddingTop: '0px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              fontWeight: '500',
              marginLeft:'-5px'
            }}
            separator=">"
          >

            <Typography style={{
              cursor: 'pointer',
              textDecoration: 'none',
              border: 'none',
              background: 'none',
              fontSize: {xs:10 , sm:16 , md:16},
              color: '#7A7A7A',
              fontWeight: '500'
            }}
              onClick={handleNavigation}
            >
              SAT Test Prep
            </Typography>

            <Typography style={{ fontWeight: '500', cursor: 'pointer' }} onClick={handleNavigateOverview}>
              {location.state?.data?.assessment_type === 'Full Test' ?
                <Typography variant="body2" style={{ fontWeight: '500', color: '#7A7A7A' , fontSize: {xs:10 , sm:16 , md:16}, }}>{"Full Test"}</Typography> :
                <Typography variant="body2" style={{ fontWeight: '500', color: '#7A7A7A' , fontSize: {xs:10 , sm:16 , md:16}, }}>
                  {
                    location.state?.data?.assessment_type === 'English Subject Test' || location.state?.data?.assessment_type === 'Maths Subject Test'
                      ? "Subject Test"
                      : (
                        location.state?.data?.data?.type === "Chapter" && location.state?.data?.data?.assessment_type === 'English Subject Test'
                          ? "Reading and Writing Chapter Test"
                          : location.state?.data?.data?.assessment_type === 'Maths Subject Test' && location.state?.data?.data?.type === "Chapter"
                            ? "Math Chapter Test"
                            : "SAT Chapter Test"
                      )
                  }
                </Typography>
              }
            </Typography>

            <Typography variant="body2" style={{ fontWeight: '600', color: '#2563EB' , fontSize: {xs:10 , sm:16 , md:16} }}>{"Test Report"}</Typography> :

          </Breadcrumbs>

          <Typography variant="h4" sx={{...(mobileLandscape ? { fontSize: "26px !important ", fontWeight: 700, color: '#000',mt:2 } : { mb: 0, mt: 2, fontWeight: 700, fontSize: {xs:'18px',sm:'32px',md:'32px'}}) }}>Your Practice Score Report</Typography>
          {/* {location.state.data?.type !== "Chapter" &&  */}
          <ScoreCard />
          {/* } */}
        </Box>
        <Box sx={{ mb: 3 }} id='box'>
          <Typography variant="h6" sx={{ fontWeight: 700, fontSize: { xs: 14, sm: 32, md: 32 } }}>Sectional Summary</Typography>
          <Typography variant="body2" sx={{ mb: 3, fontWeight: 500, color: '#595959', fontSize:{ xs: 10, sm: 16, md: 16 } }}>Review your results for each module and section evaluated with our diagnostic assessments</Typography>
          <Grid container spacing={2} id='outer-grid'>
            <Grid ref={section1Ref} item xs={12} md={6} id='inner-grid1'>
              <SectionSummary
                title={location.state?.data?.assessment_type === 'Full Test' ? "Reading & Writing" : "Module 1"}
                topicNumber={1}
                onViewSolutions={() => handleViewSolutions(
                  location.state?.data?.assessment_type === 'Maths Subject Test' ? "m1" : "rw1"
                )}
                score={location.state.data.assessment_type === 'Full Test'? englishTotalScoreFullTest : IndividualScoreModule1}
                detailsLeft={{ 
                  correct: analysisTestScore?.attemptedQuestions === 0 ? '0' : analysisTestScore?.scenarioStats?.section1?.correctCount, 
                  notes: location.state?.data?.assessment_type === 'Full Test'
                    ? '(Out of 27 questions)'
                    : location.state?.data?.assessment_type === 'English Subject Test'
                      ? '(Out of 27 questions)'
                      : location.state?.data?.assessment_type === 'Maths Subject Test'
                        ? '(Out of 22 questions)'
                        : `(Out of ${analysisTestScore?.scenarioStats?.section1?.totalQuestions} questions)`
                }}
                detailsRight={{
                  incorrect: analysisTestScore?.attemptedQuestions === 0 ? '0' : analysisTestScore?.scenarioStats?.section1?.incorrectCount,
                  notes: location.state?.data?.assessment_type === 'Full Test'
                    ? '(Out of 27 questions)'
                    : location.state?.data?.assessment_type === 'English Subject Test'
                      ? '(Out of 27 questions)'
                      : location.state?.data?.assessment_type === 'Maths Subject Test'
                        ? '(Out of 22 questions)'
                        : `(Out of ${analysisTestScore?.scenarioStats?.section1?.totalQuestions} questions)`}}
                detailsAccuracy={{
                  accuracy: (
                    (
                      (analysisTestScore?.scenarioStats?.section1?.correctCount /
                        (analysisTestScore?.scenarioStats?.section1?.correctCount +
                          analysisTestScore?.scenarioStats?.section1?.incorrectCount)) * 100
                    ).toFixed(2) + '%'
                  ),
                  notes: '(In this section)'
                }}
              />
            </Grid>
            <Grid ref={section2Ref} item xs={12} md={6} id='inner-grid2'>
              <SectionSummary
                title={location.state?.data?.assessment_type === 'Full Test' ? "Maths" : "Module 2"}
                topicNumber={2}
                onViewSolutions={() => handleViewSolutions(
                  location.state?.data?.assessment_type === 'Maths Subject Test' ? "m2" : "rw2"
                )}
                score={location.state.data.assessment_type ==='Full Test' ? mathsTotalScoreFullTest : IndividualScoreModule2}
                detailsLeft={{
                  correct: analysisTestScore?.attemptedQuestions === 0 ? '0' : analysisTestScore?.scenarioStats?.section2?.correctCount,
                  notes: location.state?.data?.assessment_type === 'Full Test'
                    ? '(Out of 22 questions)'
                    : location.state?.data?.assessment_type === 'English Subject Test'
                      ? '(Out of 27 questions)'
                      : location.state?.data?.assessment_type === 'Maths Subject Test'
                        ? '(Out of 22 questions)'
                        : `(Out of ${analysisTestScore?.scenarioStats?.section2?.totalQuestions} questions)`
                }}
                detailsRight={{
                  incorrect: analysisTestScore?.attemptedQuestions === 0 ? '0' : analysisTestScore?.scenarioStats?.section2?.incorrectCount,
                  notes: location.state?.data?.assessment_type === 'Full Test'
                    ? '(Out of 22 questions)'
                    : location.state?.data?.assessment_type === 'English Subject Test'
                      ? '(Out of 27 questions)'
                      : location.state?.data?.assessment_type === 'Maths Subject Test'
                        ? '(Out of 22 questions)'
                        : `(Out of ${analysisTestScore?.scenarioStats?.section2?.totalQuestions} questions)` }}
                detailsAccuracy={{
                  accuracy: (
                    (
                      (analysisTestScore?.scenarioStats?.section2?.correctCount /
                        (analysisTestScore?.scenarioStats?.section2?.correctCount +
                          analysisTestScore?.scenarioStats?.section2?.incorrectCount)) * 100
                    ).toFixed(2) + '%'
                  ),
                  notes: '(In this section)'
                }}                // detailsAccuracy={{ incorrect: analysisTestScore?.scenarioStats?.section2?.incorrectCount, notes: `(Out of ${analysisTestScore?.scenarioStats?.section2?.totalQuestions} questions)`  }}
              />
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ mt: 2, mb: 2 }} ref={questionAnalysisRef}>
          <Box item xs={12} md={6}>
            <QuestionWiseAnalysis />
          </Box>
        </Box>
        {/* 
      <Box sx={{ maxWidth: 1560, mx: 'auto', margin: { xs: 'auto 10px', md: 'auto 15px', lg: 'auto 20px', xl: 'auto'}}}>
        {sectionsList.map((section) => (
          <Accordion key={section.id} defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box>
                <Typography fontWeight="bold">
                  <span style={{ background: '#E9EFFD', width: '26px', height: '26px', borderRadius: '10%', display: 'inline-flex',alignItems: 'center', justifyContent: 'center', fontSize: '14px', fontWeight: 'bold', marginRight: '5px' }}>{section.id}.</span> {section.title}
                </Typography>
                <Typography
                  sx={{ color: "#1976d2", fontSize: "12px", fontWeight: 400 }}
                >
                  Customised Practice →
                </Typography>
              </Box>
              <Box sx={{    display: 'flex', flexDirection: 'row', width: '50%', alignItems: 'center'}}>
               <Typography fontSize="14px" sx={{background: '#e7ecf7ff', padding: '5px 10px', borderRadius: '4px' }}>Topic Accuracy: {section.accuracy}%</Typography>
                <Box flex={1} mx={2}>
                  <LinearProgress
                    variant="determinate"
                    value={section.accuracy}
                    sx={{ height: 6, borderRadius: 3 }}
                  />
                </Box>
              </Box>
            </AccordionSummary>

            <AccordionDetails>
              <Grid container spacing={2}>
                <Grid item sm={12} md={6}>
                  {Object.entries(section.readings).map(([heading, questions]) => (
                    <Box key={heading} mb={2}>
                      <Typography
                        variant="subtitle2"
                        color="text.secondary"
                        sx={{ mb: 1 }}
                      >
                        {heading}
                      </Typography>
                      <Grid container spacing={1}>
                        {questions.map((q) => (
                          <Grid item key={q.num}>
                            <QuestionBox num={q.num} status={q.status} />
                          </Grid>
                        ))}
                      </Grid>
                    </Box>
                  ))}
                </Grid>
                <Grid item sm={12} md={6}>
                  <Grid container spacing={2}>
                    <Box mb={2} sx={{background: '#E9EFFD', padding: '12px !important', borderRadius: '4px',  width: '100%'}} display="flex" alignItems="center" justifyContent="space-between">
                      <Grid item xs={1} sx={{    background: '#fff', display: 'flex', justifyContent: 'center',
          marginRight: '10px', height: '45px', borderRadius: '50%', alignItems: 'center', transform: 'scale(1.1)'}}>
                        <TextSnippetIcon />
                      </Grid>
                      <Grid item xs={8}>
                        <Typography variant="subtitle2" color="#000" sx={{ mb: 1, fontWeight: 700 }}>Master Your Understanding of this Topic</Typography>
                        <Typography variant="body2" sx={{ mt: 0, mb: 2, color: '#6b7280' }}>Specially designed SWOT (Strengths, Weaknesses, Opportunities and Threats) analysis of your subjects.</Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <Button variant="outlined" size="small" sx={{borderRadius: '4px', textTransform: 'none', border: '2px solid #83a7fa', color: '#83a7fa', textAlign:'end',
                                   '&:hover': {border: '2px solid #83a7fa', color: '#fff !important', backgroundColor: '#83a7fa'},
                        }}>
                          Practice Now
                        </Button>
                      </Grid>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box> */}
      </>
    );
  };



  const getButtonStyle = (tab) => {
    const baseStyle = {
      borderRadius: '4px',
      px: 3,
      py: 1,
      fontWeight: 600,
      textTransform: 'none',
      border: 'none'
      //   transition: 'all 0.3s ease',
    };

    if (activeTab === tab) {
      return {
        ...baseStyle,
        background: 'linear-gradient(45deg, #1f4ed8 30%, #3b82f6 90%)',
        color: '#fff',
        boxShadow: '0 4px 20px rgba(31, 78, 216, 0.4)',
        border: '2px solid #1f4ed8',
        '&:hover': {
          background: 'linear-gradient(45deg, #1e40af 30%, #2563eb 90%)',
          boxShadow: '0 6px 25px rgba(31, 78, 216, 0.5)',
        }
      };
    }

    return {
      ...baseStyle,
      backgroundColor: '#fff',
      color: '#1f4ed8',
      border: '2px solid #e5e7eb',
      '&:hover': {
        backgroundColor: '#f8fafc',
        border: '2px solid #1f4ed8',
        transform: 'translateY(-1px)',
        boxShadow: '0 2px 10px rgba(31, 78, 216, 0.2)',
      }
    };
  };

  const ViewSolutionPage = () => {


    return (
      <>
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>QQuestion-wise Analysiss</Typography>


          <Paper sx={{ borderRadius: 2 }} elevation={0}>
            <Box sx={{ width: "100%" }}>
              <Tabs
                value={activeTabs}
                onChange={handleTabChangeTabs}
                id="tabSwitcher"
                variant="fullWidth"
                sx={{
                  width: "100%",
                  borderBottom: "1px solid #ddd",
                  minHeight: "35px",
                  ".MuiTabs-flexContainer": {
                    width: "100%",
                  },
                  ".MuiTabs-indicator": {
                    height: "3px",
                    borderRadius: "3px",
                  },
                }}
              >
                {visibleTabs?.map((tab) => (
                  <Tab
                    key={tab.id}
                    value={tab.id}
                    label={tab.label}
                    sx={{
                      fontWeight: 600,
                      textTransform: "none",
                      minHeight: "48px",
                      padding:{ xs:"8px 10px", sm:"10px 14px",md:"12px 16px" },
                      flex: 1,
                      color: activeTabs === tab.id ? "#3dcefaff !important" : "#000",
                      background: activeTabs === tab.id ? "#E9EFFD" : "#fff",
                      borderBottom:
                        activeTabs === tab.id ? "2px solid #225AD6 !important" : "none",
                      fontSize:{xs:10 , sm:14 , md:18}
                    }}
                  />
                ))}
              </Tabs>
            </Box>



          </Paper>
        </Box>
      </>
    );
  };

  return (
    <Box sx={{ p: { xs: 2, md: 7 }, bgcolor: '#ffffff', minHeight: '100vh' }}>
      <Box sx={{ maxWidth: 1560, mx: 'auto', margin: { xs: 'auto 30px',sm: 'auto 30px', md: 'auto 60px', lg: 'auto 60px', xl: 'auto' } }}>
        {/* <Header /> */}


        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
          <ButtonGroup variant="outlined" sx={{ background: '#fff', visibility: 'hidden', padding: '14px 40px', borderRadius: '8px', border: '1px solid #ddd' }} aria-label="Report view options">
            <Button sx={{
              ...getButtonStyle('report'), border: 'none',
              '&:hover': { border: 'none' },
            }}
            // onClick={() => handleTabChange('report')}
            >
              View Report
            </Button>

            {location.state?.data?.assessment_type !== 'Full Test' && location.state?.data?.data?.type !== "Chapter" &&
              <Button

                sx={{
                  ...getButtonStyle('solution'), border: 'none',
                  '&:hover': { border: 'none' },
                }}
              >
                View Solution
              </Button>}
          </ButtonGroup>
        </Box>

        {activeTab === 'report' && <ViewReportPage />}
        {activeTab === 'solution' && <ViewSolutionPage />}
      </Box>
      {isLoading && (
          <Backdrop
            open
            sx={{ color: '#000', zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: 'rgba(255,255,255,0.9)' }}
          >
            <Box role="status" aria-live="polite" display="flex" flexDirection="column" alignItems="center">
              <CircularProgress color="primary" size={60} thickness={4} />
              <Typography variant="h6" sx={{ mt: 2, color: 'text.primary' }}>
                Loading assessment...
              </Typography>
            </Box>
          </Backdrop>
        )}
    </Box>
  );
}


export default SATReportReplica;